import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Container,
  MenuItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.png';

function Vmsheader() {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [menuItems, setMenuItems] = useState([
    { label: 'Terms & Conditions', route: null },
  ]);

  // Optional: State to trigger re-run of useEffect
  const [storageChanged, setStorageChanged] = useState(0);

  // Opens the mobile navigation menu
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  // Closes the mobile navigation menu
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  // Handles the click on each menu item (navigate and then close menu)
  const handleMenuItemClick = (route) => {
    if (route) {
      navigate(route);
    }
    handleCloseNavMenu();
  };

  useEffect(() => {
    // Fetch and convert values from localStorage
    const profile = localStorage.getItem('profile') === 'true';
    const induction = localStorage.getItem('induction') === 'true';
    const visitor = localStorage.getItem('visitor') === 'true';

    // Initialize an array with base menu items
    const updatedMenuItems = [
      { label: 'Terms & Conditions', route: null },
      { label: 'Privacy Policy', route: null },
    ];

    // Conditionally add menu items based on localStorage values
    if (profile) {
      updatedMenuItems.push({ label: 'Profile', route: '/vms/profile' });
    }
    if (induction) {
      updatedMenuItems.push({ label: 'Inductions', route: '/vms/induction' });
    }
    if (visitor) {
      updatedMenuItems.push(
        { label: 'Tasks', route: '/vms/task_&_Notify' },
        { label: 'My History', route: '/vms/history' },
        { label: 'Check Out', route: '/vms/checkout' }
      );
    }

    // Update the state with the new menu items
    setMenuItems(updatedMenuItems);
  }, [storageChanged]); // Re-run when storageChanged updates

  // Listen for changes in localStorage (from other tabs/windows)
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'profile' || event.key === 'induction' || event.key === 'visitor') {
        setStorageChanged((prev) => prev + 1);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Optional: Function to update localStorage and trigger re-render
  // const updateLocalStorage = (key, value) => {
  //   localStorage.setItem(key, value);
  //   setStorageChanged((prev) => prev + 1);
  // };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Left side: logo */}
          <Box
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', mr: 2 }}
            onClick={() => navigate('/')} // navigate to home or any route on logo click
          >
            <img src={Logo} alt="logo" width={50} height={50} />
          </Box>

          {/* Right side: menu icon */}
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton
              size="large"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>

            {/* The mobile menu itself */}
            <Menu
              id="mobile-menu"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
            >
              {menuItems.map((item) => (
                <MenuItem
                  key={item.label}
                  onClick={() => handleMenuItemClick(item.route)}
                >
                  <Typography textAlign="center">
                    {item.label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Vmsheader;
